import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { IBus } from "@/domain/entities/lineInfo";
import { ref, PropType, onMounted, computed } from "vue";
import InlineSvg from "vue-inline-svg";
import SwiperCore, { EffectCoverflow, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.scss";
import { CACHED_BUS_IMAGE_KEY_PREFIX, Effect } from "@/types";
import { useFileStore } from "@/stores/fileStore";
import { useRoute } from "vue-router";


const __default__ = {
  name: "BusInfoModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  buses: {
    type: Array as PropType<IBus[]>,
    required: true,
  },
},
  emits: ["onClickClose", "onClickApply"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "9649366a-busImageHeightPx": (busImageHeightPx.value)
}))

SwiperCore.use([EffectCoverflow, Navigation, Pagination]);

const props = __props;

const emit = __emit;

const route = useRoute();
const fileStore = useFileStore();

const showModal = ref(true);
const emitOnClickClose = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClickClose");
  }, 300);
};

const swiperOptions = {
  modules: [EffectCoverflow],
  effect: "coverflow" as Effect,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 0,
    modifier: 1,
    slideShadows: false,
  },
  centeredSlides: true,
  loop: false,
  slidesPerView: 1,
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  paginationClickable: false,
};

const getBusImage = async (index: number) => {
  const targetImage = selectedBus.value.busImages?.[index];

  if (!targetImage?.fileUid) return;

  const fileUrlResult = await fileStore.getFileUrl(
    targetImage.fileUid,
    true,
    CACHED_BUS_IMAGE_KEY_PREFIX
  );

  targetImage.fileUrl =
    fileUrlResult.data ?? require("@/assets/images/no-image.png");
};

const getSelectedBusesImageAll = async () => {
  const fetchBusImageAPIs: (() => void)[] = [];

  selectedBus.value.busImages?.forEach(async (_, index) => {
    fetchBusImageAPIs.push(() => getBusImage(index));
  });

  await Promise.all(fetchBusImageAPIs.map((fetch) => fetch()));
};

const slicePlateNumber = (plateNumber: string) => {
  if (plateNumber.length > 4) return plateNumber.slice(-4);

  return plateNumber;
};

const handleBusImageTagError = (event: Event) => {
  const target = event.target as HTMLImageElement;
  target.src = "@/assets/images/no-image.png";
};

const swiperInstance = ref();
const onSwiper = async (swiper: SwiperCore) => {
  swiperInstance.value = swiper;
};

const selectedBus = computed(() => props.buses[selectedIndex.value]);
const selectedIndex = ref(0);
const selectBusNumber = (index: number) => {
  if (selectedIndex.value !== index) {
    selectedIndex.value = index;
    swiperInstance.value?.slideToLoop(0, 300);
    getSelectedBusesImageAll();
  }
};

const busImageWrapper = ref<HTMLElement>();
const busImageHeightPx = ref("0px");

onMounted(() => {
  route.meta.onBackHandlerList.push(emitOnClickClose);
  busImageHeightPx.value = `${
    (busImageWrapper.value?.clientWidth ?? 0) * 0.64
  }px`;
  getSelectedBusesImageAll();
});

const __returned__ = { props, emit, route, fileStore, showModal, emitOnClickClose, swiperOptions, getBusImage, getSelectedBusesImageAll, slicePlateNumber, handleBusImageTagError, swiperInstance, onSwiper, selectedBus, selectedIndex, selectBusNumber, busImageWrapper, busImageHeightPx, get InlineSvg() { return InlineSvg }, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})